import React, { Component } from "react";
import { Card, Button, Form, Icon, Grid, List, Table } from "tabler-react";
import Select from "react-select";
import { Crud_Catalogos, Crud_error } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import { timeToDateFill, timeToDateNumbers, timeToYearmonthDay } from "../../herramientas/DateFormat";
import { ArrobaIncidencia } from "./Arroba";
import { forEach } from "jszip";
import { Checkbox } from "@mui/material";
import VisualizadorArchivos from "./VisualizadorArchivos";
let reader = new FileReader();
let upImages = [];
const TIPOS_IMPO = [1, 3, 72, 336];
const TIPOS_EXPO = [2, 4, 73, 138, 204, 205, 337, 534];
/**
 * usuario
 */
const user = JSON.parse(sessionStorage.getItem("usuario"));
class MovimientoIncidenciasForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      incidencias: {
        value: 0,
        label: "Selecciona  tipo de incidencia",
        data: null,
      },
      personalizados :[],
      incidenciasPlataforma: [],
      comentario: "",
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      disabledSave: true,
      latitud: "",
      longitud: "",
      etaManual: null,
      enviar: false,
      destinosClientes: [],
      destinosTransportistas: [],
      destinosMonitoreo: [],
      listarIncidencias: [],
      whatsAppGrupos: [],
      contactosCorreo: "",
      contactosWhatsApp: "",
      imagenesTotal: 0,
      showVisualizadorArchivos: false,
    };
    this.enableSave = this.enableSave.bind(this);
    this.movimientoIncidencia = [];
    this.privilegio = [];
    this.sevenIncidencias = [];
    this.usuariosLogObject = {
      idBitacoraMonitoreo: 0,
      idUsuario: 0,
      idMovimiento: 0,
      accionFecha: "",
      descripcion: "",
      idPlataformaTipo: "",
    };
  }
  componentDidMount = () => {
    upImages = [];
    this.getfuntion(
      "get",
      [],
      "",
      "incidencias/idplataforma/" + this.props.movimiento.idPlataforma.id,
      "incidenciasAll"
    );
    if (this.state.accion === "nuevo") {
      let latitud = "";
      let longitud = "";
      if (this.props.latitud) {
        latitud = this.props.latitud;
      } else {
        latitud = this.props.gpsReciente ? this.props.gpsReciente.latitud : "";
      }
      if (this.props.longitud) {
        longitud = this.props.longitud;
      } else {
        longitud = this.props.gpsReciente
          ? this.props.gpsReciente.longitud
          : "";
      }
      this.movimientoIncidencia = {
        idMovimiento: this.props.idmovimiento,
        comentario: "",
        fechaCreado: null,
        atencionUsuario: this.props.idusuario,
        atencionFecha: null,
        latitud: latitud,
        longitud: longitud,
        etaManual: null,
        destinosMonitoreo: [],
        destinosClientes: [],
        destinosTransportistas: [],
        incidencia: {},
      };

      

      this.setState({ latitud: latitud });
      this.setState({ longitud: longitud });
      this.setState({ etaManual: this.state.etaManual });
    } else {
      this.setState({ incidencias: this.props.elementos.incidencias });
      this.setState({ comentario: this.props.elementos.comentario });
    }
  };

  enableSave = () => {
    if (this.state.incidencias.value > 0) {
      return false;
    } else {
      return true;
    }
  };
  guardarIncidencia = async () => {
    let variables = {};
    this.state.personalizados.map((variable,i) => {
      let nameField = variable.nombre 
     
      variables[nameField] = this.state[nameField] == "on" && variable.tipo == 'boolean' ? true : 
      variable.tipo == 'boolean' && this.state[nameField] == undefined ? false : this.state[nameField] == undefined ? "": this.state[nameField];
      
    });    
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post(variables);
    this.props.cerrarModal();
  };
  delete() {
    this.props.getfuntion("delete", "", this.props.elementos.id);
  }
  crud_put() {
    this.props.getfuntion("put", this.movimientoIncidencia);
  }
  crud_post(variables) {
    //console.log(variables)
    this.movimientoIncidencia.comentario = this.state.comentario;
    this.movimientoIncidencia.incidencia = this.state.incidencias.data;
    this.movimientoIncidencia.etaManual = this.state.etaManual;
    this.movimientoIncidencia.latitud = this.state.latitud;
    this.movimientoIncidencia.longitud = this.state.longitud;
    this.movimientoIncidencia.personalizados = JSON.stringify(variables);
    //Crea la incidencia y luego envia  correo si asi de sea
    this.getfuntion(
      "post",
      this.movimientoIncidencia,
      "",
      "movimientoIncidencias",
      "incidencias",
      this.props.closeModal,
      this.state.enviar
    );
  }

  getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "",
    stateVar = "",
    hiddenModl = "",
    enviar
  ) => {
    Crud_Catalogos(
      catalogo,
      "movimientos",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    )
      .then((returnVal) => {
        /**
         * filtro de variables
         */
        switch (metodo) {
          case "get":
            if (stateVar === "destinosClientes") { 
              console.log("destinosClientes", returnVal);
              let contactosCorreo= this.state.contactosCorreo;
              let contactosWhatsApp= this.state.contactosWhatsApp;
              for(let p of returnVal){
                contactosCorreo=
                  contactosCorreo + (contactosCorreo.length> 0? ", ": "") + 
                  "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.correo+">";
                  if( p.whatsappEstatus && p.telefono && p.telefono.length === 10){
                    contactosWhatsApp=
                      contactosWhatsApp + (contactosWhatsApp.length> 0? ", ": "") + 
                      "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.telefono+">'";
                  }
              }
              this.setState({
                contactosCorreo: contactosCorreo,
                contactosWhatsApp: contactosWhatsApp
              });
              this.setState({ destinosClientes: returnVal });
              //this.movimientoIncidencia.destinosClientes = returnVal;
              return returnVal;
            }
            if (stateVar === "destinosTransportistas") { 
              console.log("destinosTransportistas", returnVal);
              let contactosCorreo= this.state.contactosCorreo;
              let contactosWhatsApp= this.state.contactosWhatsApp;
              for(let p of returnVal){
                contactosCorreo=
                  contactosCorreo + (contactosCorreo.length> 0? ", ": "") + 
                  "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.correo+">";
                  if( p.whatsappEstatus && p.telefono && p.telefono.length === 10){
                    contactosWhatsApp=
                      contactosWhatsApp + (contactosWhatsApp.length> 0? ", ": "") + 
                      "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.telefono+">'";
                  }
              }
              this.setState({
                contactosCorreo: contactosCorreo,
                contactosWhatsApp: contactosWhatsApp
              });
              this.setState({ destinosTransportistas: returnVal });
              //this.movimientoIncidencia.destinosTransportistas = returnVal;
              return returnVal;
            }
            if (stateVar === "destinosMonitoreo") { 
              console.log("destinosMonitoreo", returnVal);
              let contactosCorreo= this.state.contactosCorreo;
              let contactosWhatsApp= this.state.contactosWhatsApp;
              for(let p of returnVal){
                contactosCorreo=
                  contactosCorreo + (contactosCorreo.length> 0? ", ": "") + 
                  "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.correo+">";
                  if( p.whatsappEstatus && p.telefono && p.telefono.length === 10){
                    contactosWhatsApp=
                      contactosWhatsApp + (contactosWhatsApp.length> 0? ", ": "") + 
                      "'"+p.nombre + (p.aPaterno? " "+p.aPaterno: "") + (p.aMaterno? " "+p.aMaterno: "")+"' <"+p.telefono+">'";
                  }
              }
              this.setState({
                contactosCorreo: contactosCorreo,
                contactosWhatsApp: contactosWhatsApp
              });
              this.setState({ destinosMonitoreo: returnVal });
              //this.movimientoIncidencia.destinosMonitoreo = returnVal;
              return returnVal;
            }
            if (stateVar === "whatsAppGrupos") {
              console.log("destinosMonitoreo", returnVal);
              let contactosWhatsApp= this.state.contactosWhatsApp;
              for(let wg of returnVal){
                contactosWhatsApp= contactosWhatsApp + (contactosWhatsApp.length> 0? ", ": "") + wg.nombreGrupo;
              }
              this.setState({ contactosWhatsApp: contactosWhatsApp });
              this.setState({ whatsAppGrupos: returnVal });
              return returnVal;
            }
            if (stateVar === "listarIncidencias") {
              this.setState({ listarIncidencias: returnVal });
            }

            if (stateVar === "incidenciasAll") {
              let incidenciasTemp = [];
              returnVal.map((inc, index) => {
                incidenciasTemp.push({
                  value: inc.id,
                  label: inc.nombre,
                  data: inc,
                });
              });
              this.setState({ incidenciasPlataforma: incidenciasTemp });
            }
            break;
          case "post":
            {
              
              if (stateVar === "incidencias") {
                let destMonitoreo = "";
                let destTransportistas = "";
                let destClientes = "";
                if(this.state.destinosMonitoreo){
                this.state.destinosMonitoreo.forEach((key, index) => {
                  destMonitoreo = destMonitoreo + ", " + key.correo;
                });
               }
                if(this.state.destinosTransportistas){
                   this.state.destinosTransportistas.forEach((key, index) => {
                  destTransportistas = destTransportistas + ", " + key.correo;
                });
                }
               
                if(this.state.destinosClientes){
                   this.state.destinosClientes.forEach((key, index) => {
                  destClientes = destClientes + ", " + key.correo;
                });
                }
               
                this.usuariosLogObject.idBitacoraMonitoreo = 2;
                this.usuariosLogObject.idUsuario = user.id;
                this.usuariosLogObject.idMovimiento = this.props.movimiento.id;
                this.usuariosLogObject.idPlataformaTipo = 1;
                this.usuariosLogObject.accionFecha = timeToDateFill(
                  new Date().getTime()
                );
                this.usuariosLogObject.descripcion =
                  returnVal.incidencia.nombre;
                Crud_Catalogos(
                  "usuariosLog",
                  this.catalogo,
                  "post",
                  "",
                  this.usuariosLogObject,
                  "",
                  "",
                  "",
                  ""
                );
                if([61,1711].includes(this.props.movimiento.idPlataforma.id) && returnVal.incidencia && returnVal.incidencia.id === 10693){//plataforma_evidencia_archivo
                    // Subir archivos a plataforma_evidencia_archivo
                    let formDataArchivos = new FormData();
                    formDataArchivos.append("fecha", timeToYearmonthDay(new Date(this.props.movimiento.creationDate).getTime()));
                    formDataArchivos.append("conf", 1);
                    for(let imagen of upImages){
                        let archivoRenombrado = new File([imagen], 1+"_"+this.props.movimiento.idPlataforma.id+"_"+this.props.movimiento.id+"_"+returnVal.id+"_"+timeToDateNumbers(new Date().getTime())+"."+imagen.name.split('.').pop(), {
                            type: imagen.type,
                            lastModified: imagen.lastModified,
                        });
                        formDataArchivos.append("archivos", archivoRenombrado);
                    }
                    Crud_Catalogos("plataforma_evidencia_archivo/subir-archivos", "plataforma_evidencia_archivo", "post", "", formDataArchivos);
                }
                if (enviar && returnVal.id) {
                  ArrobaIncidencia(this.props.movimiento.idPlataforma.id, this.props.movimiento, returnVal.id, upImages, this.state.incidencias.data.idEtiqueta).then((arrobaInc) => {
                    this.getfuntion(
                      "get",
                      "",
                      "",
                      "movimientoAcumuladores/mov/" + this.props.movimiento.id,
                      "acumuladores"
                    );
                    NotificationManager.info(
                      arrobaInc,
                      "envio de correo incidencia"
                    );
                    this.usuariosLogObject.idBitacoraMonitoreo = 6;
                    this.usuariosLogObject.idUsuario = user.id;
                    this.usuariosLogObject.idMovimiento =
                      this.props.movimiento.id;
                    this.usuariosLogObject.idPlataformaTipo = 1;
                    this.usuariosLogObject.accionFecha = timeToDateFill(
                      new Date().getTime()
                    );
                    this.usuariosLogObject.descripcion =
                      "Notificación de incidencia(" +
                      returnVal.incidencia.nombre +
                      "): " +
                      destMonitoreo +
                      " " +
                      destTransportistas +
                      " " +
                      destClientes +
                      " " +
                      arrobaInc;
                    Crud_Catalogos(
                      "usuariosLog",
                      this.catalogo,
                      "post",
                      "",
                      this.usuariosLogObject,
                      "",
                      "",
                      "",
                      ""
                    );
                  });
                }
                /**
                 * 130	ONE-LINE
                 * Si es Oneline y ya esta capturado arribo a cliente ya no actualiza en full(esto permitira capturar otras como inicio de ruta)
                 */
                let actualizaFull= true;
                if( [130,61].includes(this.props.movimiento.idPlataforma.id)){
                  if(TIPOS_IMPO.includes(this.props.movimiento.idMovimientoTipo.id()) && this.props.movimiento.arriboClienteLleno() !== null)
                    actualizaFull= false;
                  /*
                  if(TIPOS_EXPO.includes(this.props.movimiento.idMovimientoTipo.id()) && this.props.movimiento.arriboClienteVacio() != null)
                    actualizaFull= false;
                  */
                }
                if (
                  actualizaFull &&
                  this.props.movimiento.actualizarFull &&
                  this.props.movimientoFull && this.props.movimientoFull.id
                ) {


                  console.log("actualizo full")
                  let incidenciaFull = {
                    atencionFecha: null,
                    atencionUsuario: obj.atencionUsuario,
                    comentario: obj.comentario,
                    fechaCreado: null,
                    idMovimiento: this.props.movimientoFull.id,
                    incidencia: obj.incidencia,
                    latitud: obj.latitud,
                    longitud: obj.longitud,
                  };
                  incidenciaFull = this.getfuntion(
                    "post",
                    incidenciaFull,
                    "",
                    "movimientoIncidencias",
                    "newIncidenciaFull",
                    "",
                    enviar
                  );
                }
              }
              if (stateVar === "newIncidenciaFull") {
                let destMonitoreo = "";
                let destTransportistas = "";
                let destClientes = "";

                if(this.state.destinosMonitoreo){
                  this.state.destinosMonitoreo.forEach((key, index) => {
                    destMonitoreo = destMonitoreo + ", " + key.correo;
                  });
                }
                if(this.state.destinosTransportistas){
                   this.state.destinosTransportistas.forEach((key, index) => {
                  destTransportistas = destTransportistas + ", " + key.correo;
                });
                }
                if(this.state.destinosClientes){
                this.state.destinosClientes.forEach((key, index) => {
                  destClientes = destClientes + ", " + key.correo;
                });
              }
                NotificationManager.info(
                  returnVal.comentario,
                  "Nueva incidencia movFull (" + returnVal.idMovimiento + ")"
                );
                this.usuariosLogObject.idBitacoraMonitoreo = 2;
                this.usuariosLogObject.idUsuario = user.id;
                this.usuariosLogObject.idMovimiento = this.props.movimientoFull.id;
                this.usuariosLogObject.idPlataformaTipo = 1;
                this.usuariosLogObject.accionFecha = timeToDateFill(
                  new Date().getTime()
                );
                this.usuariosLogObject.descripcion =
                  returnVal.incidencia.nombre;
                Crud_Catalogos(
                  "usuariosLog",
                  this.catalogo,
                  "post",
                  "",
                  this.usuariosLogObject,
                  "",
                  "",
                  "",
                  ""
                );
                //Envia Arroba y Nueva Incidencia Naviero
                if (enviar && returnVal.id && this.props.movimientoFull.id) {
                  ArrobaIncidencia(this.props.movimientoFull.idPlataforma.id, this.props.movimientoFull.id, returnVal.id, upImages, this.state.incidencias.data.idEtiqueta).then((arrobaInc) => {
                    NotificationManager.info(
                      arrobaInc,
                      "envio de correo incidencia"
                    );
                    this.usuariosLogObject.idBitacoraMonitoreo = 6;
                    this.usuariosLogObject.idUsuario = user.id;
                    this.usuariosLogObject.idMovimiento = returnVal.idMovimiento;
                    this.usuariosLogObject.idPlataformaTipo = 1;
                    this.usuariosLogObject.accionFecha = timeToDateFill(
                      new Date().getTime()
                    );
                    this.usuariosLogObject.descripcion =
                      "Notificación de incidencia(" +
                      returnVal.incidencia.nombre +
                      "): " +
                      destMonitoreo +
                      " " +
                      destTransportistas +
                      " " +
                      destClientes +
                      " " +
                      arrobaInc;
                    Crud_Catalogos(
                      "usuariosLog",
                      this.catalogo,
                      "post",
                      "",
                      this.usuariosLogObject,
                      "",
                      "",
                      "",
                      ""
                    );
                  });
                }
              }
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.log("Error desconocido ...." + err);
      });
  };
  changeIncidencias = async (event) => {
    this.setState({ incidencias: event });
    if (event.data.idEtiqueta) {
      await this.getfuntion(
        "get",
        [],
        "",
        "personas/destinatarios_clientes_incidencias/" +
          this.props.idmovimiento +
          "/" +
          event.data.idEtiqueta,
        "destinosClientes"
      );
      await this.getfuntion(
        "get",
        [],
        "",
        "personas/destinatarios_transportistas_incidencias/" +
          this.props.idmovimiento +
          "/" +
          event.data.idEtiqueta,
        "destinosTransportistas"
      );
      await this.getfuntion(
        "get",
        [],
        "",
        "personas/destinatarios_sky_naviera_incidencias/" +
          this.props.idmovimiento +
          "/" +
          event.data.idEtiqueta,
        "destinosMonitoreo"
      );
      await this.getfuntion(
        "get",
        [],
        "",
        "whatsapp_grupos/mov/" + this.props.idmovimiento+"/"+event.data.idEtiqueta,
        "whatsAppGrupos"
      );
      this.getfuntion(
        "get",
        [],
        "",
        "movimientoIncidencias/movimiento/" + this.props.idmovimiento,
        "listarIncidencias"
      );      
      this.setState({ enviar: true });
    } else {
      this.setState({ destinosClientes: [] });
      this.setState({ destinosTransportistas: [] });
      this.setState({ destinosMonitoreo: [] });
      this.setState({ listarIncidencias: [] });
      this.setState({ enviar: false });
    }

    this.setState({personalizados:event.data.variablesIncidencias})
  };

  changeComentario = (event) => {
    this.setState({ comentario: event.target.value });
  }

  changeLongitud = (event) => {    
      this.setState({ longitud: event.target.value });
    
  };

  changeLatitud = (event) => {    
      this.setState({ latitud: event.target.value });    
  };

  changeEtaManual = (event) => {
    this.setState({ etaManual: event.target.value });
  };

  changeEnviar = (e) => {
    this.setState({ enviar: e.target.checked });
  };

  fileOnloadNew = (e) => {
    document.querySelector('img[name="prev"]').src = reader.result;
  };
  onChangeImage = (event) => {
    try {
      const files = Array.from(event.target.files);
      if (upImages.length + files.length > 5) {
        alert("Máximo 5 archivos permitidos");
        return;
      }
      files.forEach(file => {
        upImages.push(file);
        const reader = new FileReader();
        reader.onload = (e) => {
          const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file.name);
          
          if (isImage) {
            const img = document.createElement('img');
            img.src = e.target.result;
            img.style.width = '80px';
            img.style.height = '80px';
            img.style.margin = '5px';
            img.style.border = '1px solid #ccc';
            document.getElementById('imagePreviewNav').appendChild(img);
          } else {
            const fileDiv = document.createElement('div');
            fileDiv.style.width = '80px';
            fileDiv.style.height = '80px';
            fileDiv.style.margin = '5px';
            fileDiv.style.border = '1px solid #ccc';
            fileDiv.style.display = 'flex';
            fileDiv.style.alignItems = 'center';
            fileDiv.style.justifyContent = 'center';
            fileDiv.style.backgroundColor = '#f8f9fa';
            fileDiv.innerHTML = '<i class="fa fa-file" style="font-size: 32px; color: #6c757d;"></i>';
            document.getElementById('imagePreviewNav').appendChild(fileDiv);
          }
        };
        reader.readAsDataURL(file);
      });
      this.setState({ imagenesTotal: upImages.length });
    } catch (error) {}
  };

  /**
   * Privilegio activo
   */
  estaPrivilegioActivo = (clave) => {
    var privilegios = this.props.stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (privilegios[i].clave === clave) {
        if (
          perfil.privilegios.filter(
            (word) => word.idPrivilegio == privilegios[i].id
          ).length > 0
        ) {
          this.privilegio = privilegios[i];
          return true;
        } else {
          return false;
        }
        break;
      }
    }
  };

  render() {
    return (
      <div>
        {this.state.accion === "modificar" ? (
          <h1> {this.props.elementos.comentario} </h1>
        ) : null}
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={8} lg={8}>
                <Form.Group label="incidencias">
                  <Select
                    value={this.state.incidencias}
                    onChange={this.changeIncidencias}
                    options={this.state.incidenciasPlataforma}
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={2} lg={2}>
                <Form.Group label="Latitud">
                  <Form.Input
                    name="latitud"
                    type="text"
                    value={this.state.latitud}
                    onChange={!this.props.gpsReciente ? this.changeLatitud : null}
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={2} lg={2}>
                <Form.Group label="Longitud">
                  <Form.Input
                    name="longitud"
                    type="text"
                    value={this.state.longitud}
                    onChange={!this.props.gpsReciente ? this.changeLongitud : null}
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={9}>
                <Form.Group label="Comentario">
                  <Form.Textarea
                    name="comentario"
                    type="text"
                    value={this.state.comentario}
                    onChange={this.changeComentario}
                    maxlength="50"
                  />
                </Form.Group>
              </Grid.Col>
              {[61,530,985,721,1316,1711,952].includes(this.props.movimiento.idPlataforma.id) && !this.props.gpsReciente ? (
              <Grid.Col md={3} lg={3}>
                <Form.Group label="Eta Manual">
                  <Form.Input
                    name="etaManual"
                    type="text"
                    value={this.state.etaManual}
                    onChange={this.changeEtaManual}
                  />
                </Form.Group>
              </Grid.Col>
              ) : null }
              <Grid.Col md={12} lg={12}>
                <div>
                  <Form.Group
                    label={
                      this.state.incidencias.value
                      && this.state.incidencias.value === 9
                      && [61,1711].includes(this.props.movimiento.idPlataforma.id)
                        ? "Archivos (Se incluiran con evidencia Pods)"
                        : "Imagenes"}
                  >{/** //plataforma_evidencia_archivo */}
                    <input
                      type="file"
                      id="imagen"
                      ref={this.fileInput}
                      className="file"
                      accept="image/*"
                      multiple
                      onChange={this.onChangeImage}
                    />
                      <div
                        id="imagePreviewNav"
                        style={{display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', overflowX: 'auto', marginTop: '10px', gap: '5px'}}
                      ></div>
                      { !this.state.imagenesTotal && <i className="fa fa-folder-open" style={{fontSize: '48px', color: 'blue'}}></i> }
                      
                    <Button
                      className= 'float-right badge'
                      data-toggle="tooltip"
                      data-placement="top"
                      title={'Pegar imagen'}
                      target="_blank"
                      size="sm"
                      RootComponent="a"
                      color="primary"
                      pill
                      onClick={(e) => {
                        try {
                          if (upImages.length >= 5) {
                            alert("Máximo 5 imágenes permitidas");
                            return;
                          }
                          navigator.clipboard.read().then((data) => {
                            for (let i = 0; i < data.length; i++) {
                              if (!data[i].types.includes("image/png")) {
                                alert("No parece ser una imagen");
                              } else {
                                data[i]
                                  .getType("image/png")
                                  .then((blob) => {
                                    const file = new File(
                                      [blob],
                                      "imagen" + new Date().getTime() + ".png"
                                    );
                                    upImages.push(file);
                                    
                                    const reader = new FileReader();
                                    reader.onload = (e) => {
                                      const img = document.createElement('img');
                                      img.src = e.target.result;
                                      img.style.width = '80px';
                                      img.style.height = '80px';
                                      img.style.margin = '5px';
                                      img.style.border = '1px solid #ccc';
                                      document.getElementById('imagePreviewNav').appendChild(img);
                                    };
                                    this.setState({ imagenesTotal: upImages.length });
                                    reader.readAsDataURL(file);
                                  });
                              }
                            }
                          });
                        } catch (error) {}
                      }}
                    >
                      <span class="badge"><i className="fa fa-paste" style={{fontSize: "15px"}}></i></span>
                    </Button>
                  </Form.Group>
                </div>
              </Grid.Col>
             
              { this.state.personalizados.length > 0  ?
              
              <>
                  {this.state.personalizados.map((variable,i) => {
                   let nameField = variable.nombre 
                  return <Grid.Col md={6} lg={3}>
                    <Form.Group label={variable.idEtiqueta}>
                      {variable.tipo == "varchar" ?
                      <Form.Input
                        name={nameField}
                        value={this.state.nameField}
                        onChange={(e)=>  this.setState({ [e.target.name]: e.target.value })}
                      />:
                       variable.tipo == "text" ?
                        <Form.Textarea
                        name={nameField}
                        value={this.state.nameField}
                        onChange={(e)=>  this.setState({ [e.target.name]: e.target.value })}
                      />:
                      variable.tipo == "boolean" ?
                      <Checkbox
                      name={nameField}
                      value={this.state.nameField}
                      onChange={(e)=>  this.setState({ [e.target.name]: e.target.value })}
                      />:
                        null
                      
                       }
                        
                      </Form.Group>
                  </Grid.Col>
                  
                  })}
              </>
              
              :

              null
              }
             
              <Grid.Col md={12}>
                <Form.Group label="Enviar correo">
                  {this.estaPrivilegioActivo("arroba_incidencia") ? (
                    <Form.Switch
                      type="Checkbox"
                      checked={this.state.enviar}
                      onChange={this.changeEnviar}
                    />
                  ) : (
                    <Form.Switch type="Checkbox" checked={false} />
                  )}
                </Form.Group>
                {this.state.destinosClientes ? (
                  <List.Group>
                    <h3>
                      {this.state.destinosClientes.length > 0
                        ? "Cliente"
                        : null}
                    </h3>
                    {this.state.destinosClientes.map((cliente, index) => (
                      <List.GroupItem action icon="rss">
                        <div className="row">
                          <div className="col-5">
                            {" "}
                            <Icon name="user" />
                            {cliente.nombre +
                              " " +
                              cliente.aPaterno +
                              " " +
                              cliente.aMaterno}{" "}
                          </div>
                          <div className="col-5">
                            {" "}
                            <Icon name="mail" />
                            {cliente.correo}{" "}
                          </div>
                        </div>
                      </List.GroupItem>
                    ))}
                  </List.Group>
                ) : null}
                {this.state.destinosTransportistas ? (
                  <List.Group>
                    <h3>
                      {this.state.destinosTransportistas.length > 0
                        ? "Transportista"
                        : null}
                    </h3>
                    {this.state.destinosTransportistas.map((transp, index) => (
                      <List.GroupItem action icon="rss">
                        <div className="row">
                          <div className="col-5">
                            {" "}
                            <Icon name="user" />
                            {transp.nombre +
                              " " +
                              transp.aPaterno +
                              " " +
                              transp.aMaterno}{" "}
                          </div>
                          <div className="col-5">
                            {" "}
                            <Icon name="mail" />
                            {transp.correo}{" "}
                          </div>
                        </div>
                      </List.GroupItem>
                    ))}
                  </List.Group>
                ) : null}
                {this.state.destinosMonitoreo ? (
                  <List.Group>
                    <h3>
                      {this.state.destinosMonitoreo.length > 0 ? "Otros" : null}
                    </h3>
                    {this.state.destinosMonitoreo.map((moni, index) => (
                      <List.GroupItem action icon="rss">
                        <div className="row">
                          <div className="col-5">
                            {" "}
                            <Icon name="user" />
                            {moni.nombre +
                              " " +
                              moni.aPaterno +
                              " " +
                              moni.aMaterno}{" "}
                          </div>
                          <div className="col-5">
                            {" "}
                            <Icon name="mail" />
                            {moni.correo}{" "}
                          </div>
                        </div>
                      </List.GroupItem>
                    ))}
                  </List.Group>
                ) : null}
                {this.state.enviar ? (
                  this.state.destinosClientes.length > 0 ||
                  this.state.destinosTransportistas.length > 0 ||
                  this.state.destinosMonitoreo.length > 0 ? null : (
                    <List.GroupItem action icon="rss">
                      {" "}
                      Al parecer no se ha configurado la plantilla, o no hay
                      destinatarios, revise su configuración{" "}
                    </List.GroupItem>
                  )
                ) : null}
              </Grid.Col>
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <div class="row">
          <div className="col col-12 col-md-12">
            <Card title="Lista de Incidencias">
              <Card.Body>
                <Table
                  cards={true}
                  striped={true}
                  responsive={true}
                  className="table-vcenter"
                  headerItems={[
                    { content: "Id" },
                    { content: "Nombre" },
                    { content: "Fecha" },
                    { content: "Incidencia tipo" },
                    { content: "Personalizados"}
                  ]}
                >
                  <Table.Body>
                    {
                      //   this.state.newResult.map((res)=>{
                      //    return(
                      <Table.Row>
                        <Table.Col></Table.Col>
                        <Table.Col></Table.Col>
                        <Table.Col></Table.Col>
                        <Table.Col></Table.Col>
                      </Table.Row>
                      //  )
                      //  })
                    }
                  </Table.Body>
                </Table>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="float-right">
          <span class="badge">
            <Button
              target="_blank"
              size="sm"
              RootComponent="a"
              color="primary"
              disabled={this.enableSave()}
              onClick={this.guardarIncidencia}
            >
              <span class="badge">
                <Icon link={true} name="save" />
                Guardar incidencia
              </span>
            </Button>
          </span>
          {this.state.accion === "modificar" ? (
            <span class="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                onClick={() => this.delete()}
              >
                <span class="badge">
                  <Icon link={true} name="trash" />
                  Borrar
                </span>
              </Button>
            </span>
          ) : null}
          { [61,1711].includes(this.props.movimiento.idPlataforma.id)?//plataforma_evidencia_archivo
            <span class="badge">
              <Button
                size="sm"
                RootComponent="a"
                color="info"
                onClick={() => this.setState({ showVisualizadorArchivos: true })}
              >
                <span class="badge">
                  <Icon link={true} name="image" />
                  Ver Archivos
                </span>
              </Button>
            </span>
          : null}
        </div>
        {[61,1711].includes(this.props.movimiento.idPlataforma.id)?//plataforma_evidencia_archivo
          <VisualizadorArchivos
            show={this.state.showVisualizadorArchivos}
            onHide={() => this.setState({ showVisualizadorArchivos: false })}
            conf={1}
            fecha={timeToYearmonthDay(new Date(this.props.movimiento.creationDate))}
            nombre={this.props.movimiento? (1+"_"+this.props.movimiento.idPlataforma.id+"_"+this.props.movimiento.id): ""}
          />
        :null}
      </div>
    );
  }
}
export default MovimientoIncidenciasForm;
